import { defineStore } from 'pinia';

export const useParamsStore = defineStore('params', {
  state: () => {
    return {
      yoienVersion: '1.0',
      yoienClient: 'CLIENTA1/1.0',
      requestId: 'c8380ae5-bef0-5c9f-af9d-4686b55d93eb',
      projectId: '',
      customerProjectName: '',
      idToken: '',
      userId: '',
      systemRole: -1,
    };
  },
  getters: {},
  actions: {
    setProjectId(projectId: string) {
      this.projectId = projectId;
    },
    setIdToken(idToken: string) {
      this.idToken = idToken;
    },
    setUserId(userId: string) {
      this.userId = userId;
    },
    setSystemRole(systemRole: number) {
      this.systemRole = systemRole;
    },
    setCustomerProjectName(customerProjectName: string) {
      this.customerProjectName = customerProjectName;
    },
  },
  // persist setting call
  persist: {
    storage: piniaPluginPersistedstate.localStorage(),
  },
});
